import React from 'react';
import { StyledNav } from './Nav.styles';

const Nav = ({ children }) => {
    return (
        <StyledNav data-testid="nav">
            { children }
        </StyledNav>
    )
}

export default Nav;